import { render, staticRenderFns } from "./customerMgt.vue?vue&type=template&id=f0532890&scoped=true&"
import script from "./customerMgt.vue?vue&type=script&lang=js&"
export * from "./customerMgt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0532890",
  null
  
)

export default component.exports